import { slides } from "./selectors"

const store = {
  totalSlides: slides.length,
}

// For debugging
window.store = store

export const initializeStore = (config) => {
  store.index = config.start_slide > 1 ? config.start_slide - 1 : 0
  store.logging = {}
  store.slideshow = slideshare_object.slideshow
}

export default store
